import { Button, Flex, Icon, Spinner, Text } from '@wyz/ui';
import { sumBy, uniq } from 'lodash-es';
import { Link } from 'react-router';
import { Trans } from '~/common/context';
import { IUserCustomer } from '~/common/types';
import { useManageCart } from '~/purchase/api';
import { usePurchaseContext } from '~/purchase/context';

type Props = { customer?: IUserCustomer };
function CartStatus({ customer }: Props) {
  const purchaseContext = usePurchaseContext();
  const cart = useManageCart({
    context: { customerId: customer?.id as string },
    get: { enabled: true },
  });
  const isCartFetched = cart.get.isSuccess && cart.get.isFetched;

  return (
    <Flex className='space-x-1'>
      <div className='bg-white p-1 rounded-1' style={{ height: '2.5rem' }}>
        <div className='fw-semi-bold fs-xxs'>
          <Trans i18nKey='app.purchase.cart_page.in_your_cart' />
        </div>
        {isCartFetched && cart.get.data?.data.items.length ? (
          <>
            <Text color='secondary' heading='xs' id='cart-items-count'>
              <Trans
                i18nKey='app.purchase.cart_count'
                values={{
                  referenceCount: uniq(
                    cart.get.data.data.items.map((item) => item.tyre.ean),
                  ).length,
                  productCount: sumBy(cart.get.data.data.items, 'quantity'),
                }}
              />
            </Text>
          </>
        ) : cart.get.isProcessing ? undefined : (
          <div className='fs-xs text-title-color' data-cy='cart-items-count'>
            <Trans i18nKey='app.purchase.empty_cart' />
          </div>
        )}
      </div>
      <Button
        id='check-cart'
        variant='primary'
        size='md'
        as={Link}
        to={
          purchaseContext.isCallCenterMode
            ? '/call-center/cart'
            : '/purchase/cart'
        }
        disabled={!customer?.purchaseSearchable}
      >
        {cart.get.isProcessing ? (
          <Spinner style={{ width: 20, height: 20 }} />
        ) : (
          <div className='position-relative'>
            <Icon icon='shopping-cart' size='xs' />
            {Boolean(cart.get.data?.data.items.length) && (
              <div
                className='position-absolute bg-blue-secondary rounded-circle'
                style={{
                  left: '100%',
                  top: 0,
                  width: '0.475rem',
                  height: '0.475rem',
                }}
              ></div>
            )}
          </div>
        )}
      </Button>
    </Flex>
  );
}

export default CartStatus;
